var App = App || {};

App.WidgetTabbedCarousel = (function ($) {
    'use strict';

    let timer;
    let timerCounter = 0;
    const timerDuration = 5000;
    const timerInterval = 10;

    const controlsTabbedCarousel = $(".widget-tabbed-carousel .widget-tabbed-carousel-list button");
    const controls = $(".widget-tabbed-carousel .widget-tabbed-carousel-controls button");
    const controlsPause = $(".widget-tabbed-carousel .widget-tabbed-carousel-controls [data-tabbed-carousel='pause']");
    const controlsReset = $(".widget-tabbed-carousel .widget-tabbed-carousel-controls [data-tabbed-carousel='reset']");

    function Init(selector) {
        selector.each(function () {
            Swipe($(this));
        });

        controlsTabbedCarousel.on("click", function () {
            TabbedCarouselClear();
            TabCarouselActivate($(this));
            timer = setInterval(TabbedCarouselBehavior, timerInterval, $(this));
            controls.show();
        }).on("keydown", function (e) {
            TabCarouselKeydown($(this), e);
        });
        controlsPause.on("click", function () {
            TabbedCarouselClear();
            controlsPause.hide();
        });
        controlsReset.on("click", function () {
            TabbedCarouselClear();
            TabCarouselActivate(controlsTabbedCarousel.first());
            controls.hide();
        });
    }

    function TabbedCarouselBehavior(elem) {
        timerCounter++;
        const progressInt = 60 + timerCounter * (314 / (timerDuration / timerInterval));

        if (progressInt >= 314) {
            TabbedCarouselClear();

            var next = elem.parents("li").next("li").find("button");
            if (next.length) {
                TabCarouselActivate(next);
                timer = setInterval(TabbedCarouselBehavior, timerInterval, next);
            }
            else {
                TabCarouselActivate(controlsTabbedCarousel.first());
                controls.hide();
            }
        }
    }

    function TabbedCarouselClear() {
        clearInterval(timer);
        timerCounter = 0;
    }

    function TabCarouselActivate(elem) {

        const control = elem;
        const controlSiblings = control.parents("li").siblings("li").find("button");

        control.attr("aria-selected", true);
        controlSiblings.attr("aria-selected", false);

        const tabbedCarouselItem = $(`#${elem.attr("aria-controls")}`);
        const tabbedCarouselItemSiblings = tabbedCarouselItem.siblings(".tabbed-carousel-item");

        tabbedCarouselItem.stop().removeClass("fadeOut").fadeIn(350);
        tabbedCarouselItemSiblings.stop().addClass("fadeOut").fadeOut(350, function () {
            $(this).removeClass("fadeOut")
        });
    }

    function TabCarouselKeydown(tabbedCarouselItem, e) {

        const arrowsNext = ["ArrowRight", "ArrowDown"];
        const arrowsPrev = ["ArrowLeft", "ArrowUp"];

        if ([...arrowsNext, ...arrowsPrev].includes(e.key)) {

            let tabbedCarouselItemWhich;

            if (arrowsNext.includes(e.key)) {
                e.preventDefault();
                tabbedCarouselItemWhich = tabbedCarouselItem.parents("li").is(":last-child")
                    ? tabbedCarouselItem.parents("ul").children("li:first").find("button")
                    : tabbedCarouselItem.parents("li").next("li").find("button");
            }
            else if (arrowsPrev.includes(e.key)) {
                e.preventDefault();
                tabbedCarouselItemWhich = tabbedCarouselItem.parents("li").is(":first-child")
                    ? tabbedCarouselItem.parents("ul").children("li:last").find("button")
                    : tabbedCarouselItem.parents("li").prev("li").find("button");
            }

            tabbedCarouselItemWhich.removeAttr("tabindex").focus();
            tabbedCarouselItemWhich.parents("li").siblings("li").children("button").attr("tabindex", "-1")
            TabCarouselActivate(tabbedCarouselItemWhich);
        }
    }

    function Swipe($tabbedCarousel) {

        const speed = 250;
        const $controls = $tabbedCarousel.find('.widget-tabbed-carousel__swipe-controls button');
        const $mask = $tabbedCarousel.find('.widget-tabbed-carousel__swipe-mask');
        const $scroll = $tabbedCarousel.find('.widget-tabbed-carousel__swipe-scroll');
        const $content = $tabbedCarousel.find('.widget-tabbed-carousel__swipe-content');
        const $focus = $tabbedCarousel.find('.widget-tabbed-carousel__swipe-content *');

        if ($content.width() > $scroll.width()) {
            $tabbedCarousel.addClass('mask-fwd');
        }

        // help if content element is focused on while outside of view
        $focus.on('focus', function () {
            if ($(this).position().left + $(this).outerWidth() > $mask.width()) {
                $scroll.stop().animate({
                    scrollLeft: $(this).offset().left + $(this).outerWidth() - $mask.width() + $scroll.scrollLeft() + 36
                }, speed * 2);
            }

            if ($(this).position().left < 0) {
                $scroll.stop().animate({
                    scrollLeft: $(this).offset().left + $scroll.scrollLeft() - 78
                }, speed * 2);
            }
        });

        $controls.on('click', function () {

            const distance = (() => {
                switch ($(this).attr('data-swipe')) {
                    case 'fwd':
                        return $scroll.scrollLeft() + $scroll.width() - 100;
                    case 'back':
                        return $scroll.scrollLeft() - $scroll.width();
                    default:
                        return 0;
                }
            })();

            $scroll.stop().animate({
                scrollLeft: distance
            }, speed * 2);
        });

        $scroll.on('scroll', function () {
            Controls($tabbedCarousel, $scroll, $content, $controls, speed);
        });

        App.Base.$window.on('resize', function () {
            Controls($tabbedCarousel, $scroll, $content, $controls, speed);
        });
    }

    function Controls($tabbedCarousel, $scroll, $content, $controls, speed) {

        if ($scroll.scrollLeft() <= 10) {
            $tabbedCarousel.removeClass('mask-back');
        }
        else {
            $tabbedCarousel.addClass('mask-back');
        }

        if ($scroll.scrollLeft() >= $content.width() - $scroll.width() - 10) {
            $tabbedCarousel.removeClass('mask-fwd');
        }
        else {
            $tabbedCarousel.addClass('mask-fwd');
        }
    }


    return {
        Init: Init
    };

})(jQuery);